export default __webpack_public_path__ + "static/media/36.236fed95.png";